import {AfterContentInit, Component, OnDestroy} from '@angular/core';
import {StagesNavigationService} from '../../../stages-navigation/stages-navigation.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-experience-info-complete',
  templateUrl: './experience-info-complete.component.html',
  styleUrls: ['./experience-info-complete.component.scss']
})
export class ExperienceInfoCompleteComponent implements AfterContentInit, OnDestroy {

  interval: any;

  constructor(
    private stagesNavigationService: StagesNavigationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnDestroy(): void {
    clearTimeout(this.interval);
  }

  ngAfterContentInit(): void {
    this.interval = setTimeout(() => {
      const nextStage = this.stagesNavigationService.next();
      this.router.navigate([{outlets: {stages: nextStage.stageOutlet}}], {relativeTo: this.route.parent});
    }, 2000);
  }

}
